import styled, { css } from 'styled-components';

const HelpPage = styled.div``;

const HelpPageInfo = styled.div`
  margin-bottom: 16px;
`;

const HelpPageBody = styled.div``;

const HelpPageCards = styled.div`
  display: grid;
  grid-gap: 16px;
  grid-template-columns: 1fr 1fr 1fr;
`;

const HelpPageCard = styled.div`
  background: var(--color-bg-default);
  border: 1px solid var(--color-border-default);
  border-radius: var(--size-border-radius-md,);
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
`;

const HelpVideoCardOverlay = styled.div`
  align-items: center;
  background-color: var(--color-bg-overlay);
  display: flex;
  inset: 0;
  justify-content: center;
  opacity: 0;
  position: absolute;
  transition: opacity 0.2s;
`;

const HelpVideoCardOverlayIcon = styled.div`
  align-items: center;
  background-color: var(--color-neutral-800);
  border-radius: var(--size-border-radius-circle);
  cursor: pointer;
  display: flex;
  height: 56px;
  justify-content: center;
  width: 56px;
`;

const HelpVideoCard = styled.div`
  height: 100%;
  position: relative;
  width: 100%;

  .stop {
    display: none;
  }

  &:hover ${HelpVideoCardOverlay} {
    opacity: 1;
  }

  ${({ isPlaying }) =>
    isPlaying &&
    css`
      .start {
        display: none;
      }
      .stop {
        display: block;
      }
    `}
`;

export {
  HelpPage,
  HelpPageBody,
  HelpPageCard,
  HelpPageCards,
  HelpPageInfo,
  HelpVideoCard,
  HelpVideoCardOverlay,
  HelpVideoCardOverlayIcon
};
